export const handleDateChangeNew = (value) => {
    if (value.length === 8) {
      if (value.indexOf("/") !== -1) {
        var dateArr = value.split("/");
        if (dateArr.length === 3) {
          if (
            (dateArr[0].length === 1 || dateArr[0].length === 2) &&
            (dateArr[1].length === 1 || dateArr[1].length === 2) &&
            dateArr[2].length > 0 &&
            dateArr[2].length < 5
          ) {
            if (dateArr[0].length === 1) value = "0" + dateArr[0];
            else value = dateArr[0];
            if (dateArr[1].length === 1) value = value + "0" + dateArr[1];
            else value = value + dateArr[1];
            value = value + dateArr[2];
          }
        }
      }
      value = value.replace(/[^0-9]/g, "").trim();
      value = value.replace(/^(\d{2})/, "$1/");
      value = value.replace(/\/(\d{2})/, "/$1/");
      value = value.replace(/(\d)\/(\d{4}).*/, "$1/$2");
    }
    return value;
  };
  
  export const handleMonthChange = (value) => {
    if (value.length === 6) {
      if (value.indexOf("/") !== -1) {
        var dateArr = value.split("/");
        if (dateArr.length === 2) {
          if (
            (dateArr[0].length === 1 || dateArr[0].length === 2) &&
            dateArr[1].length > 0 &&
            dateArr[1].length < 5
          ) {
            if (dateArr[0].length === 1) value = "0" + dateArr[0];
            else value = dateArr[0];
  
            value = value + dateArr[1];
          } else {
            return false;
          }
        } else {
          return false;
        }
      }
      value = value.replace(/^[ A-Za-z()[\]+!@#$%^&*/%]*$/, "");
      value = value.replace(/^(.{2})(.*)$/, "$1/$2");
    }
    return value;
  };
  